import { set } from '@/utils/vuex'

export default {
  SET_TOKEN: set('token'),
  SET_BAR_IMAGE: set('barImage'),
  SET_DRAWER: set('drawer'),
  SET_APP_LOADING: set('appLoading'),
}
